import React from "react"

export default function ({ children }: { children: React.ReactNode }) {
  return <div className="ar-editor">{children}</div>
}
